import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../../enums'

export const CONFIGURATION_INPUT = graphql.transformers.IN.object<
  ents.extra.space.Report.Configuration.ProgressByOrganization,
  graphql.schema.SpaceReportProgressByOrganizationConfigurationInput
>({
  format: graphql.transformers.IN.nonNull(enums.format.TRANSFORMER),
  entityId: graphql.transformers.IN.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Entity.Id.isId,
    { warnOnly: true },
  ),
})
